import { Alert } from 'modules/common/utils';

const searchCompany = (searchValue, callback) => {
  // client
  //   .query({
  //     query: gql(companyQueries.companies),
  //     variables: { searchValue, page: 1, perPage: 200 }
  //   })
  //   .then(response => {
  //     callback && callback(response.data.companies);
  //   })
  //   .catch(error => {
  //     Alert.error(error.message);
  //   });
};

const searchIntegrations = (searchValue, callback) => {
  // client
  //   .query({
  //     query: gql(integrationQueries.integrations),
  //     variables: { searchValue, page: 1, perPage: 100 }
  //   })
  //   .then(response => {
  //     callback && callback(response.data.integrations);
  //   })
  //   .catch(error => {
  //     Alert.error(error.message);
  //   });
};

const searchCustomer = (searchValue, callback) => {
  // client
  //   .query({
  //     query: gql(customerQueries.customers),
  //     variables: { searchValue, page: 1, perPage: 50 }
  //   })
  //   .then(response => {
  //     callback && callback(response.data.customers);
  //   })
  //   .catch(error => {
  //     Alert.error(error.message);
  //   });
};

const searchUser = (searchValue, callback) => {
  // client
  //   .query({
  //     query: gql(userQueries.users),
  //     variables: { searchValue, page: 1, perPage: 50 }
  //   })
  //   .then(response => {
  //     callback && callback(response.data.users);
  //   })
  //   .catch(error => {
  //     Alert.error(error.message);
  //   });
};

export { searchCompany, searchCustomer, searchUser, searchIntegrations };



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/utils/searchers.js